import React from "react";
import { Section, SerifH, Eyebrow, PrimaryButton, Card } from "../components/ui-kit/Primitives";
import { GraduationCap } from "lucide-react";

const topics = [
  "How to start a peer support agency",
  "Peer support business structure",
  "Documentation basics",
  "Credentialing readiness",
  "Medicaid readiness",
  "Business funding preparation",
  "Community outreach",
  "Referral partner development",
  "Compliance basics",
  "Client intake and onboarding",
  "Leadership and agency operations",
  "Wellness education",
  "Recovery support education",
];

const Resources = () => (
  <div data-testid="resources-page">
    <Section className="pt-16">
      <div className="max-w-3xl">
        <Eyebrow>Resources & Training</Eyebrow>
        <SerifH as="h1" className="text-5xl sm:text-6xl">
          Workshops, trainings, and resources built for the peer support field.
        </SerifH>
        <p className="mt-6 text-lg text-slate-600 font-light leading-relaxed">
          We share what we know — clearly. Workshops are designed for peer support agencies,
          Certified Peer Support Specialists, behavioral health entrepreneurs, and community
          partners.
        </p>
      </div>
    </Section>

    <Section className="pt-0">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {topics.map((t) => (
          <Card key={t} className="p-7 flex items-start gap-4">
            <div className="w-10 h-10 rounded-lg bg-brand-mist flex items-center justify-center text-brand-green flex-shrink-0">
              <GraduationCap className="w-5 h-5" />
            </div>
            <div>
              <h3 className="font-serif text-xl text-brand-green leading-snug">{t}</h3>
              <div className="mt-1 text-xs tracking-[0.2em] uppercase text-brand-sage">Workshop topic</div>
            </div>
          </Card>
        ))}
      </div>
    </Section>

    <Section className="bg-brand-green text-white">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <Eyebrow color="gold">Coming up</Eyebrow>
          <SerifH className="text-4xl sm:text-5xl text-white">
            Join our next training — or request a private workshop for your team.
          </SerifH>
        </div>
        <div className="lg:col-span-4 lg:text-right">
          <PrimaryButton to="/contact" testid="resources-cta" className="bg-brand-gold text-brand-navy hover:bg-white">
            Request a Workshop
          </PrimaryButton>
        </div>
      </div>
    </Section>
  </div>
);

export default Resources;
